import { type ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'danger' | 'outline';
type Size = 'sm' | 'md' | 'lg';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const variantClass: Record<Variant, string> = {
  primary: styles['btn-primary'],
  secondary: styles['btn-secondary'],
  danger: styles['btn-danger'],
  outline: styles['btn-outline'],
};

const sizeClass: Record<Size, string> = {
  sm: styles['btn-sm'],
  md: '',
  lg: styles['btn-lg'],
};

export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}: Props) {
  return (
    <button
      className={`${styles.btn} ${variantClass[variant]} ${sizeClass[size]} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
